import {
    Show, SimpleShowLayout, TextField
    , ReferenceField, ReferenceManyField, Datagrid
    , Pagination,
    
} from "react-admin";

import { DateTimeField } from "@/src/components";
import { MessageField } from "../Message";

export const ConversationShow = () => (
    <Show >
        <SimpleShowLayout>

            <TextField source="id" />
            {/*
            <BooleanField source="deleted" />
            <NumberField source="count" />
            <DateField source="createdAt" />
            <DateField source="updatedAt" />
            <TextField source="lastMessage" />
            <DateField source="lastSent" /> 
            */}
            <ReferenceManyField
                label=""
                source="id" reference="message" target="conversation"
                sort={{ field: 'id', order: 'ASC' }}
                perPage={100}
                pagination={<Pagination rowsPerPageOptions={[50, 100, 200]} />}
            >

                <Datagrid bulkActionButtons={false} size="small" >

                    <DateTimeField source="sent" variant="caption" />
                    <ReferenceField source="sender" reference="user">
                        <TextField source="profile.nickname" variant="caption" />
                    </ReferenceField>
                    <MessageField source="content" type="type" sx={{
                        // padding: theme => theme.spacing(0.5, 1),
                        // borderRadius: "6px",
                        // borderColor: theme => theme.palette.primary.light,
                        // borderStyle: "solid",
                        // borderWidth: "2px",
                        // backgroundColor: theme => theme.palette.action.selected,
                    }} />
                </Datagrid>

            </ReferenceManyField>

        </SimpleShowLayout>
    </Show>
);
